import { useState } from "react";
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { useMatch } from "react-router-dom";
import deleteImage from "../../assets/images/delete.svg";
import editImage from "../../assets/images/edit.svg";
import { setPage } from "../../features/filter/filterSlice";
import {
  editActive,
  fetchTransactions,
  removeTransaction
} from "../../features/transaction/transactionSlice";
import numberWithCommas from "../../utils/numberWithCommas";
import Form from "../Form";

export default function Transaction({ transaction }) {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  const { id: editId } = useSelector(
    (state) => state?.transaction?.editing || {}
  );
  const match = useMatch("/transactions");
  const { page } = useSelector((state) => state?.filter || {});
  const { totalTransactions } = useSelector(
    (state) => state?.transaction || {}
  );

  const { name, amount, type, id } = transaction || {};
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(editActive(transaction));
    openModal();
  };

  const handleDelete = () => {
    dispatch(removeTransaction(id)).then(() => {
      if (!match) {
        dispatch(fetchTransactions({ page: "home" }));
      } else {
        let pageNum = page;
        if (Math.ceil((totalTransactions - 1) / 10) < page) {
          dispatch(setPage(page - 1));
          pageNum -= 1;
        }
        dispatch(fetchTransactions({ page: "transactions", pageNum }));
      }
    });
  };

  return (
    <>
      <Modal
        isOpen={modalOpen && match && editId ? true : false}
        overlayClassName="modalContainerStyle"
        className="modalStyle"
        onRequestClose={closeModal}
      >
        <Form />
      </Modal>
      <li className={`transaction ${type}`}>
        <p>{name}</p>
        <div className="right">
          <p>৳ {numberWithCommas(amount)}</p>
          <button className="link" onClick={handleEdit}>
            <img alt="Edit" className="icon" src={editImage} />
          </button>
          <button className="link" onClick={handleDelete}>
            <img alt="Delete" className="icon" src={deleteImage} />
          </button>
        </div>
      </li>
    </>
  );
}
